import React from 'react';

const PdfModal = ({ isOpen, onClose, pdfUrl }) => {
  if (!isOpen) return null;

  // Ensure the PDF URL is properly formatted
  const getPdfUrl = (url) => {
    if (url.startsWith('/')) {
      // If it's a relative path, make it absolute
      return `${window.location.origin}${url}`;
    }
    return url;
  };

  const handleBackdropClick = (e) => {
    // Only close if clicking on the backdrop, not the modal content
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div 
      className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50"
      onClick={handleBackdropClick}
    >
      <div className="bg-white rounded-lg shadow-lg max-w-4xl w-full h-[90vh] relative">
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-gray-600 hover:text-gray-900 text-1xl font-bold z-10 bg-white rounded-full w-8 h-8 flex items-center justify-center shadow-md"
          aria-label="Close PDF"
        >
          &times;
        </button>
        <div className="p-4 h-full">
          <iframe
            src={getPdfUrl(pdfUrl)}
            title="PDF Viewer"
            className="w-full h-full border-none"
            frameBorder="0"
            allowFullScreen
            onError={(e) => {
              console.error('PDF failed to load:', e);
              alert('PDF could not be loaded. Please try downloading instead.');
            }}
          ></iframe>
        </div>
      </div>
    </div>
  );
};

export default PdfModal; 